import React from 'react';
import DepartmentPaymentRequests from '../../components/DepartmentPaymentRequests';

const AccountsPaymentRequests = () => {
  return <DepartmentPaymentRequests department="ACCOUNTS" departmentLabel="Accounts Dept" />;
};

export default AccountsPaymentRequests;
